import _ from 'lodash';

export default function stripDelimiter(
  pathParts: readonly string[],
  delimiter: string,
): readonly string[] {
  return _.flatten(pathParts.map((pathPart) => pathPart.split(delimiter)));
}
